import { RobotDeadIcon } from './RobotDeadIcon';

/**
 * author: Colton Wiscombe
 * id 04405E02-7C38-409E-8F92-785431ECC76F
 * name robot-dead
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-dead.svg
 * tags
 */
export const EmoticonRobotDeadIcon = RobotDeadIcon;
export default EmoticonRobotDeadIcon